import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../shared/services/user.service';
import { UserGridRequestModel } from '../shared/models/userGridRequestModel';
import { IListItemModel } from '../shared/models/listItemModel';
import { EditEvent, GridDataResult } from "@progress/kendo-angular-grid";
import { SortInfo } from '../shared/models/sortInfoModel';
import { PageInfo } from 'src/app/shared/models/queryparams/pageinfo.model';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { PageChangeEvent } from '@progress/kendo-angular-grid';
import { ToastService } from 'src/app/shared/services/toast.service';
import { IUserGridResponse } from '../shared/models/userGridResponse';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { State } from 'src/app/state/app.state';
import { getACLicenseStatus, getLocationSelected, getLoggedInUserInfo, GetUserPermissionList, getUserType } from 'src/app/state';
import { SortDescriptor } from '@progress/kendo-data-query';
import { UserType } from '../shared/models/usertype.enum';
import { NotificationGroupPopupComponent } from '../../../shared/modalpopup/notification-Group/notification-group-popup/notification-group-popup.component';
import { DialogService } from '@progress/kendo-angular-dialog';
import { LocationService } from '../../location/shared/services/location.service';
import { LocationSelector } from 'src/app/shared/models/location-selector/location-selector-model';
import { LocationSelectorInfo } from '../shared/models/locationSelectorModel';
import * as CoreActions from 'src/app/state/actions/core.actions';
import { Location } from '../../location/shared/models/location';
import { take } from 'rxjs/operators';
import { MasterLookupService } from '../../../master/master-services/master-lookup.service';
import { TranslationLoaderFacade } from '../../localization/translation-loader.facade';
import { TranslateService } from '@ngx-translate/core';
import { LocationRelationship } from '../../location/shared/models/locationRelationship';
import { PermissionGroup } from 'src/app/master/models/permissionGroup';
import { UserDetails } from '../shared/models/userDetailsModel';

@Component({ 
  selector: 'app-user-grid',
  templateUrl: './user-grid.component.html',
  styleUrls: ['./user-grid.component.scss']
})
export class UserGridComponent implements OnInit {
  public search: string = '';
  public data: GridDataResult = {
    total: 0,
    data: [],
  };
  public show: boolean = false;
  public deactiveUser: number | null = null;
  public userStatus: number = 1;
  public showActivate: boolean = false;
  public showDeactivate: boolean = false;
  public showClearButton: boolean = false;
  public isLocationSelctorDisabled: boolean = false;

  public anchor: any;
  public userType: UserType | null = null;
  public locationId: number = 0;
  public locationName: string | undefined = '';
  public userPermissionList: number[] = [];
  public subLocationList: LocationRelationship[] = [];
  public isAddUsersEnabled$: Observable<boolean>;
  public isEditUsersEnabled$: Observable<boolean>;
  public permissionGroupList: PermissionGroup[] | null = null;
  public isActivateDeactivateUsersEnabled$: Observable<boolean>;
  private isACLicenseEnabled$: Observable<boolean>;
  private homeLocationDetail: Location | undefined;
  private subscriptions = new Subscription();
  public selectedPermissionGroup = -1;

  public activeDeactivateDisabledMsg: string = 'You do not have the permission to activate/deactivate users';
  public pageSize: number = 25;
  public pageInfo: PageInfo = { PageSize: this.pageSize, Page: 1 };
  public sortInfo: SortInfo = { sortDirection: 1, SortColumn: 'userCode' };
  public sort: SortDescriptor[] = [{
    field: 'userCode',
    dir: 'asc'
  }];
  public userGridForm: FormGroup = new FormGroup({
    searchUser: new FormControl(),
    activeStatus: new FormControl(),
    permissionGroup: new FormControl(),
    includeSubLocations: new FormControl(),
  });
  public activeStatusList: IListItemModel[] = [
    { id: 1, displayValue: 'Active' },
    { id: 0, displayValue: 'Inactive' },
    { id: -1, displayValue: 'All' }
  ];
  

  constructor(public fb: FormBuilder,
    private dialogService: DialogService,
    public userService: UserService,
    private router: Router,
    public toastService: ToastService,
    private store: Store<State>,
    public locationService: LocationService,
    private lookupService: MasterLookupService,
    private translationLoaderFacade: TranslationLoaderFacade,
    private translateService: TranslateService, ){
      
    this.isACLicenseEnabled$ = new Observable<boolean>();
    this.isAddUsersEnabled$ = new Observable<boolean>();
    this.isEditUsersEnabled$ = new Observable<boolean>();
    this.isActivateDeactivateUsersEnabled$ = new Observable<boolean>();
  }

  ngOnInit() {
    this.translateService.get(['_General_All_Text_','_General_Active_Ts_Text_','_General_Inactive_Ts_Text_', '_User_No_Permission_For_Activate_Users_Ts_Text_']).subscribe(
      (translations) => {
        this.activeStatusList = [ 
        { id: -1, displayValue: translations['_General_All_Text_'] },
        { id: 1, displayValue: translations['_General_Active_Ts_Text_'] },
        { id: 0, displayValue: translations['_General_Inactive_Ts_Text_'] } ]
        this.activeDeactivateDisabledMsg = translations['_User_No_Permission_For_Activate_Users_Ts_Text_'];
      }
    )
    this.store.select(GetUserPermissionList).subscribe((allUserPermissions) => {
      if (allUserPermissions == undefined) {
        throw Error("preferrallUserPermissionsedTimeZone was undefined! Which was not expected!")
      }

      this.userPermissionList = allUserPermissions;
    });

    this.isACLicenseEnabled$ = this.store.select(getACLicenseStatus);
    this.SetAcLocationState();
    const homeLocationCodeSubscription = this.store.select(getLoggedInUserInfo)
      .subscribe((loggedInUserInfo) => {
        if (loggedInUserInfo != null && loggedInUserInfo != undefined && loggedInUserInfo.homeLocationCode != undefined) {

          this.locationService.getLocationByCode(loggedInUserInfo.homeLocationCode).
            subscribe((response: any) => {
              this.homeLocationDetail = response;
              if (response.locationType.id == 5) {
                this.isLocationSelctorDisabled = true;
                this.userGridForm.controls['includeSubLocations'].setValue(false);
                this.userGridForm.controls['includeSubLocations'].disable();
              }
            });
        }
      });

    //Set signed in users home location as the default location when loading the user grid
    const locationCodeSubscription = this.store.select(getLocationSelected)
      .subscribe((location) => {
        if (location.homeLocationId !== undefined && location.homeLocationId !== null) {
          this.subscriptions.add(
            this.store.select(getLoggedInUserInfo).subscribe(userInfo => {
              /**Added this check to prevent redundant API calls when the token is refreshed and the subscription
              is automatically triggered when the page is idle.(Identified in BCDT-1554) **/

              if (this.subLocationList.length === 0 && userInfo != null) {
                this.subscriptions.add(
                  this.locationService.getSubLocations(userInfo.homeLocationId).subscribe(subs => {
                    this.subLocationList = subs;
                    const mappedLocation = subs.map(subLocs => subLocs.id);

                    if (location.homeLocationId == undefined) {
                      throw Error("location.homeLocationId was undefined! Which was not expected!")
                    }

                    if (mappedLocation.includes(location.homeLocationId)) {
                      this.locationId = location.homeLocationId;
                      this.locationName = location.locationName;
                    } else {
                      this.locationId = userInfo.homeLocationId;
                      this.locationName = userInfo.homeLocationName;
                    }

                    this.loadUserGridWithFilters();
                  })
                )
              }
            })
          )
        }
      });

    const userType = this.store.select(getUserType)
      .subscribe((userType) => {
        if (userType !== undefined && userType !== null) {
          this.userType = userType;
        }
      });

    this.pageInfo = { PageSize: this.pageSize, Page: 1 };
    this.userGridForm = this.fb.group({
      searchUser: new FormControl(""),
      activeStatus: new FormControl(this.activeStatusList[0].id),
      includeSubLocations: new FormControl(true),
      permissionGroup: new FormControl(null)
    });

    this.userService.setEditingUser(null);

    this.subscriptions.add(
      this.userGridForm.controls.searchUser.valueChanges.subscribe({ next: val => this.onSearchTextChanges(val) })
    );

    this.subscriptions.add(locationCodeSubscription);

    this.subscriptions.add(this.isACLicenseEnabled$.subscribe((data: boolean) => {
      if (data) {
        this.getMeetingPreference();
      }
    }));

    this.subscriptions.add(homeLocationCodeSubscription);
    
    this.lookupService.getPermissiongGroups(true).subscribe({
      next: (permissionGroups) => {
        this.permissionGroupList = permissionGroups;
      },
      error: (err) => { console.log(err) }
    })
    this.userService.confUserId = '';

  }



  private getVCProvider() {
    this.subscriptions.add(this.userService.meetingPreferencData.subscribe(preferences => {
      let meetingPref = JSON.parse(preferences.toString());
      if (meetingPref.virtual) {
        this.getConferencingProvider();
      }
    }));
  }

  /**
   * Load user grid according to the selected filter values
   */
  public loadUserGridWithFilters() {
    let userGridRequestModel = this.getGridParams();
    this.userService.getUsersForTheGrid(userGridRequestModel).subscribe((response: IUserGridResponse) => {
      this.data = {
        total: response.totalRowCount,
        data: response.data,
      };
    },
      error => {
        console.log(error);
      });

  }
  public onLocationDataRecived(locationdata: LocationSelector) {

    var selectedObj = locationdata.locationsFlatData.find(l => l.locationId == this.locationId);
    if (selectedObj == undefined && this.homeLocationDetail != undefined) {
      var locationSelectorInfo: LocationSelectorInfo = {
        id: this.homeLocationDetail?.id,
        locationName: this.homeLocationDetail?.name,
        locationCode: this.homeLocationDetail?.code,
        locationTypeId: this.homeLocationDetail?.locationType?.id,
        utcoffsetInMinutes: this.homeLocationDetail?.timeZone?.utcoffsetInMinutes,
        timezoneId: this.homeLocationDetail?.timeZone?.timeZoneId,
        timeZoneName: this.homeLocationDetail?.timeZone?.timeZoneName,
        dropDownDisabled: null,
        lastLocationAutoWraupTime: this.homeLocationDetail?.lastLocationAutoWraupTime
      };


      this.store.dispatch(CoreActions.updateLocationSelectorInfo({ payload: { locationSelectorInfo: locationSelectorInfo } }));
      this.store.dispatch(CoreActions.updateACLocationSelectorInfo({ payload: { acLocationCode: locationSelectorInfo.locationCode } }));


    }

  }
  /**
   * Create the user grid params according to the current filters
   */
  private getGridParams(): UserGridRequestModel {
    if (this.userType == undefined) {
      throw Error("this.userType was undefined! Which was not expected!")
    }

    let userGridRequestModel = new UserGridRequestModel();
    userGridRequestModel.IncludeSubLocations = this.userGridForm.controls.includeSubLocations.value;
    userGridRequestModel.PageInfo = this.pageInfo;
    userGridRequestModel.SearchText = this.userGridForm.controls.searchUser.value.toLowerCase();
    userGridRequestModel.Status = this.userGridForm.controls.activeStatus.value;
    userGridRequestModel.SortInfo = this.sortInfo;
    userGridRequestModel.LocationId = this.locationId;
    userGridRequestModel.UserType = this.userType;
    userGridRequestModel.RequestFrom = "";
    userGridRequestModel.PermissionGroupId = this.userGridForm.controls.permissionGroup.value;
    return userGridRequestModel;
  }

  public onToggle(event?: any): void {
    this.show = !this.show;
  }

  /**
   * Sort user grid and filter data according to the selected values
   * @param event Sort details
   */
  public sortChange(event: SortDescriptor[]) {
    this.sortInfo = {
      SortColumn: event[0]?.field,
      sortDirection: event[0]?.dir === 'asc' ? 1 : 2
    };
    this.sort = [{
      field: this.sortInfo.SortColumn,
      dir: this.sortInfo.sortDirection === 1 ? 'asc' : 'desc'
    }];
    this.loadUserGridWithFilters();
  }

  /**
  * Populate users for the Grid page after Initial Load
  */
  public onPageChange(event: PageChangeEvent) {
    this.pageInfo.Page = (event.skip / this.pageInfo.PageSize) + 1;
    this.loadUserGridWithFilters();
  }

  /**
   * Fires when users changes status drop down
   * -1 = All
   *  1 = Active
   *  0 = Inactive
   */
  public onStatusChanged() {
    this.pageInfo.Page = 1;
    this.userStatus = this.userGridForm.controls.activeStatus.value;
    this.loadUserGridWithFilters();
  }

  public onPermissionGroupChanged() {
    this.pageInfo.Page = 1;
    this.selectedPermissionGroup = this.userGridForm.controls.permissionGroup.value;
    this.loadUserGridWithFilters();
  }

  /**
   * Fires when users inputs something to search field
   */
  public searchKeyWordChange() {
    this.pageInfo.Page = 1;
    this.loadUserGridWithFilters();
  }

  /**
   * Captures all exsisting parameters and proceed API
   * call with the subLocationChanged property
   */
  subLocationsChanged() {
    this.pageInfo.Page = 1;
    this.loadUserGridWithFilters();
  }

  /**
  Sets the user to deactivate and waits for users confirmation
  */
  deactivateUser(dataItem: any) {
    this.deactiveUser = dataItem.userId;
    this.show = !this.show;
    this.showDeactivate = !this.showDeactivate;
  }

  /**
   * Initiate deactivation of the selected user via API call
   */
  public onDeactiveUser(): void {
    if (this.deactiveUser == undefined) {
      throw Error("this.deactiveUser was undefined! Which was not expected!")
    }
    this.show = false;
    this.showDeactivate = false;
    this.userService.deactivateUser(this.deactiveUser).subscribe((data) => {
      this.loadUserGridWithFilters();
      this.toastService.showSuccess('_User_User_Deactivated_Ts_Text_');
    },
    error => {
      console.log(error);
      this.toastService.showError('_User_User_Deactivation_Failed_Ts_Text_');
    });
  }
  /**
  Open the notification group popup
  */
  openNotificationGroupPopup() {

  }
  /**
  Sets the user to deactivate and waits for users confirmation
  */
  activateUser(dataItem: any) {
    this.deactiveUser = dataItem.userId;
    this.showActivate = !this.showActivate;
  }

  /**
   * Initiate deactivation of the selected user via API call
   */
  public onActiveUser(): void {
    if (this.deactiveUser == undefined) {
      throw Error("this.deactiveUser was undefined! Which was not expected!")
    }
    this.show = false;
    this.showActivate = false;
    this.userService.activateUser(this.deactiveUser).subscribe((data) => {
      this.loadUserGridWithFilters();
      this.toastService.showSuccess('_User_User_Activated_Ts_Text_');
    },
    error => {
      console.log(error);
      this.toastService.showError('_User_User_Activation_Failed_Ts_Text_');
    });
  }

  /**
   * Resets Sets the deactivate user code
   */
  public onNoClick(): void {
    this.show = false;
    this.showActivate = false;
    this.showDeactivate = false;
    this.deactiveUser = null
  }

  /**
   * Navigated user to the user settings page
   */
  goToUserSettings() {
    this.userService.setEditingUser(null);
    this.userService.setPageMode('Add');
    this.router.navigate(['admin/user/user-settings']);
  }

  /**
   * set the users to be eddited in user service
   */
  editHandler(event: EditEvent) {
    const { dataItem, rowIndex } = event;
    this.userService.getUser(dataItem.userId).subscribe((userData) => {
      this.userService.setEditingUser(userData);
      this.userService.setPageMode('Edit');
      this.router.navigate(['admin/user/user-settings']);
    });
  }

  /**
   * Filter grid when pressing the cross icon in the search text box
   */
  public onClearSearchTextClicked() {
    this.userGridForm.controls.searchUser.setValue('');
    this.loadUserGridWithFilters();
  }

  /**
   * Show hide cross icon depends on the availability of the search text
   * @param val search text
   */
  private onSearchTextChanges(val: string) {
    this.updateSearchTextClearButtonVisibility(val);
  }

  private updateSearchTextClearButtonVisibility(searchText: string) {

    if (searchText && searchText !== '') {
      this.showClearButton = true;
    } else {
      this.showClearButton = false;
    }
  }

  public openGroupNotificationPopUp(notificationGroupList: Array<string>) {
    const dialog = this.dialogService.open({
      content: NotificationGroupPopupComponent,
    });
    dialog.content.instance.notifiactionGroupList = notificationGroupList;
    dialog.content.instance.filteredList = notificationGroupList;

  }
  private SetAcLocationState() {


    const locationACCodeSubscription = this.store.select(getLocationSelected).pipe(take(1)).subscribe((location) => {
      if (location.homeLocationCode !== undefined && location.homeLocationCode !== null) {

        this.store.dispatch(CoreActions.updateACLocationSelectorInfo({ payload: { acLocationCode: location.homeLocationCode } }));
      }
    });

    this.subscriptions.add(locationACCodeSubscription);
  }
  getMeetingPreference() {
    this.userService.getMeetingPreferences().subscribe({
      next: (data) => {
        this.userService.setMeetingPreferences(data);
        this.getVCProvider();
      },
      error : () => {
       // this.toastService.showError('_General_Failed_Retrieving_Meeting_Preference_Ts_Text_'); commented out the error message until resolve the mp error
      }
    }); 
  }

  getConferencingProvider() {
    this.userService.getConferencingProvider().subscribe({
      next: (data) => {
        this.userService.setConferencingProvider(data);
      },
      error : () => {
        this.toastService.showError('_User_Failed_Retrieving_Confereing_Provider_Ts_Text_');
      }
    });
  }
  onIncludeSubLocationsChange() {
    this.pageInfo.Page = 1;
    this.loadUserGridWithFilters();
  }
  onLocationChange(location: LocationSelectorInfo) {
    if(location.id == undefined || location.id == null){
      throw Error("location.id was undefined or null! Which was not expected!");
    }
    this.locationId = location.id;
    this.locationName = location.locationName;
    //if selected location is branch, disable the includeSubLocations checkbox
    if (location.locationTypeId == 5) {
      this.userGridForm.controls['includeSubLocations'].disable();
      this.userGridForm.controls['includeSubLocations'].reset();
      this.userGridForm.controls['includeSubLocations'].setValue(false);
    }
    else {
      this.userGridForm.controls['includeSubLocations'].enable();
    }
    this.pageInfo.Page = 1;
    this.loadUserGridWithFilters();

  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
